import React from 'react'
import {NavLink} from 'react-router-dom'
import styled from 'styled-components'

import CategoryIcons from '../assets/CategoryIcons'
import SiteIcons from '../assets/SiteIcons'

import { AvailableCategories } from '../scripts/AvailableCategories'

const SecondaryNav = (props) => {

    const SecondaryNavStyles = styled.nav`
      background-color: ${props.themeStyles.sideNavigationBackground};

      &.categories {
        ul {
          border-right: solid 1px ${props.themeStyles.borderColor};
          }
        }
    `

    const SecondaryNavLink = styled(NavLink)`
      color: ${props.themeStyles.sideNavigationText};

      svg {
        * {
          fill: ${props.themeStyles.sideNavigationText};
        }
      }

      &:hover {
        color: ${props.themeStyles.sideNavigationHover};
      }

      &.active {
        color: ${props.themeStyles.sideNavActive};

        svg {
          * {
            fill: ${props.themeStyles.sideNavActive};
          }
        }
      }
    `

    const NavChange = () => {
      props.navChange()
    }

    let mobileClass

    if ( props.mobile === true ) {
      mobileClass = 'mobile'
    } else {
      mobileClass = ''
    }

    let activeClass

    if ( props.secondaryNavType === props.navType ) {
      activeClass = props.activeState
    } else {
      activeClass = ''
    }

    let withSubNav

    if ( props.showSubNav === true ) {
      withSubNav = 'withSubNav'
    } else {
      withSubNav = ''
    }

    return (
      <SecondaryNavStyles id="secondaryNav" className={props.navType + ' ' + withSubNav + ' ' + activeClass + ' ' + mobileClass}>
        {props.navType === 'categories' &&
          <ul>
            <li><SecondaryNavLink exact activeClassName="active" onClick={NavChange} to="/courses/all-courses"><CategoryIcons /><span>All Courses</span></SecondaryNavLink></li>
            {props.categories.map((link) => {
              let catURL
              AvailableCategories.map(cat => {
                if ( link[0] === cat.id ) {
                  catURL = cat.url
                }
              })
              return <li key={link[0]}><SecondaryNavLink exact activeClassName="active" onClick={NavChange} to={'/courses/' + catURL}><CategoryIcons icon={link[0]} /><span>{link[1]}</span></SecondaryNavLink></li>
            })}
          </ul>
          }
      </SecondaryNavStyles>
    )


}

export default SecondaryNav
